import { render, staticRenderFns } from "./DisabledLogin.vue?vue&type=template&id=108d7fd2&scoped=true&"
import script from "./DisabledLogin.vue?vue&type=script&lang=js&"
export * from "./DisabledLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108d7fd2",
  null
  
)

export default component.exports